// Milla brand illustrations (warm editorial, AI-generated placeholders — swap with your own)
const BASE =
  "https://static.prod-images.emergentagent.com/jobs/097727d1-3068-493c-9afd-14b03f2439cc/images";

export const ART = {
  hero:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/7osebacp_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_40_18%20PM.png",
  spaceReclaimed:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/q3dg55nm_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2004_01_35%20PM.png",
  // Official milla brand illustrations (user-provided)
  phoneUpload:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/z63ezwrh_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_06_48%20PM.png",
  stepTakePhotos:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/44jch2oc_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_08_20%20PM.png",
  stepGetEstimate:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/mnxyxd89_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_14_25%20PM.png",
  stepBookPickup:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/96qnt5ns_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_15_36%20PM.png",
  truckSchedule:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/96qnt5ns_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_15_36%20PM.png",
  estimateReceipt:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/mnxyxd89_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_14_25%20PM.png",
  stepEnjoySpace:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/gihhpmfj_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_33_02%20PM.png",
  transformGarageGym:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/rzj2gun2_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2004_28_21%20PM.png",
  transformBasementOffice:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/kiimu1b5_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2004_34_22%20PM.png",
  transformStoragePlayroom:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/59uyjakt_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2004_24_54%20PM.png",
  transformClutterFreedom:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/ytq3femz_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2004_37_33%20PM.png",
  objectSofa:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/3atc90g9_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_33_02%20PM.png",
  objectBoxes:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/lr3r0wqh_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_48_29%20PM.png",
  objectMattress:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/qjiqpi58_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_40_37%20PM.png",
  objectAppliance:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/1k6n0u3t_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_51_13%20PM.png",
  objectOffice:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/mh1x25ct_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2004_17_43%20PM.png",
  objectHotTub:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/yofnzaj1_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_52_39%20PM.png",
  trustCrew:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/cz7wylzi_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2003_00_31%20PM.png",
  trustDonation:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/ucfwwgvl_Untitled%20design.png",
  finalCta:
    "https://customer-assets.emergentagent.com/job_milla-transform/artifacts/db00kzu1_ChatGPT%20Image%20Jun%2018%2C%202026%2C%2002_29_09%20PM.png",
};
